import { FunctionComponent, lazy, Suspense } from 'react';

const ViewMoreButton = lazy(() => import('../../buttons/ViewMoreButton'));

interface ComponentProps {
  onClick: () => void;
  customDataTestId?: string;
}

interface LazyProps {
  props: ComponentProps;
}

const LazyViewMoreButton: FunctionComponent<LazyProps> = ({ props }: LazyProps) => (
  <Suspense fallback={null}>
    <ViewMoreButton {...props} />
  </Suspense>
);

export default LazyViewMoreButton;
